import { SxProps } from "@mui/material"

export const sxPagination: SxProps = {
	width: 'auto',
	height: '32px',
	background: 'unset',
	color: 'unset',
	fontSize: 'unset',
	fontStyle: 'unset',
	fontWeight: 'unset',
	lineHeight: 'unset',
	position: 'unset',
	button: {
			fontFamily: 'UnimedSans-Bold',
			backgroundColor: '#EEE',
			color: '#5F5F5F'
	}
}

export const sxPaginationContrast: SxProps = {
	...sxPagination,
	'& .MuiPaginationItem-root': {
    backgroundColor: 'black',
    color: '#FFFF00',
    border: '1px solid white'
  },
	'& .MuiPaginationItem-page.Mui-selected': {
		backgroundColor: '#FFFF00',
		color: 'black',
	},
	'& .MuiPaginationItem-page:hover': {
		backgroundColor: 'lightyellow', // Background color for the hovered page
	},
}